export default "__VITE_ASSET__Bpx1yzdR__"